import React from 'react';
import { Tag, TagColor } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';

type CardType = string | number;
export function getCardType(obj_type: any) {
    const obj_type_key = obj_type.toUpperCase();
    const cardType = CardTypeMap[obj_type_key as keyof typeof CardTypeMap] || CardTypeMap.GROUP;
    return cardType;

}
enum CardTypeMap {
    GROUP = 1,
    PROGRAM = 2,
    SESSION = 4,
    LECTURER = 5,
    MICRO_PAGES = 11,
}
const sessionTypeMap: Record<number, string> = {
    1: lang('问卷小节'),
    2: lang('提问小节'),
    3: lang('讨论小节'),
    4: lang('拍照小节'),
    5: lang('游戏小节'),
    6: lang('签到小节'),
    7: lang('微课小节'),
    8: lang('抽奖小节'),
    9: lang('报名小节'),
    10: lang('考试小节'),
    11: lang('视频小节'),
    12: lang('直播小节'),
    18: lang('直播小节'),
    13: lang('文章小节'),
    14: lang('文档小节'),
    15: lang('图文小节'),
    16: lang('作业小节'),
    17: lang('会议小节'),
    19: lang('AI微课小节'),
    20: lang('阶段点评小节'),
};
interface ICardTypeProps {
    cardType: CardType;
    sessionType?: number | string;
}

export const CardTag = (props: ICardTypeProps) => {
    const { cardType, sessionType } = props;
    let cardTypeNum = Number(cardType);
    if(Number.isNaN(cardTypeNum)) {
        cardTypeNum = getCardType(cardType);
    }
    const sessionTypeNum = Number(sessionType);
    let tagInfo: {
        color?: TagColor;
        border?: boolean;
        label: string;
        ghost?: boolean;
        hidden?: boolean;
    } = {
        label: '',
    };
    switch (cardTypeNum) {
        case CardTypeMap.GROUP:
            tagInfo = {
                color: 'blue',
                label: lang('课程'),
                border: true,
                ghost: true,
            };
            break;
        case CardTypeMap.PROGRAM:
            tagInfo = {
                color: 'green',
                label: lang('学习项目'),
                border: true,
                ghost: true,
            };
            break;
        case CardTypeMap.SESSION:
            const sessionTagName = sessionTypeMap[sessionTypeNum] || lang('小节');
            tagInfo = {
                color: 'default',
                label: sessionTagName,
                border: true,
                ghost: true,
            };
            break;
        case CardTypeMap.LECTURER:
            tagInfo = {
                color: 'default',
                label: lang('讲师'),
                border: false,
            };
            break;
        case CardTypeMap.MICRO_PAGES:
            tagInfo = {
                color: 'blue',
                label: lang('微页面'),
                border: true,
                ghost: true,
            };
            break;
        default:
            tagInfo = {
                color: 'orange',
                label: lang('链接'),
                border: true,
                ghost: true,
                hidden: true,
            };
    }
    return !tagInfo.hidden ? (
        <Tag color={tagInfo.color || 'default'} border={tagInfo.border} ghost={!!tagInfo.ghost}>
            {tagInfo.label}
        </Tag>
    ) : null
};

